import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import { LoadingState } from '../states/StateViews';

/** Blocks super admin, admin, and CMS from the public student site. */
export function RedirectStaffFromStudentSite() {
  const { status, usesAdminConsoleOnly } = useAuth();

  if (status === 'loading') {
    return <LoadingState label="Loading…" />;
  }

  if (status === 'authenticated' && usesAdminConsoleOnly) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}

/** @deprecated Use RedirectStaffFromStudentSite */
export const RedirectAdminsFromStudent = RedirectStaffFromStudentSite;
